import baseURL from "../common/axios";

class ScheduleMasterService {
  insert(objinsert) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ScheduledMas/Create", objinsert);
  }

  getdata() {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ScheduledMas/List");
  }

  Edit(EditId) {
    debugger;
    return baseURL.httpMSInventoryUrl.get("ScheduledMas/Get?id=" + EditId + "");
  }

  Delete(DelID) {
    debugger;
    return baseURL.httpMSInventoryUrl.delete("ScheduledMas/Delete?id=" + DelID);
  }

  active(DelID, Status) {
    debugger;
    return baseURL.httpMSInventoryUrl.put(
      "ScheduledMas/Active?id=" + DelID + "&Status=" + Status + ""
    );
  }

  Update(objupdate) {
    debugger;
    return baseURL.httpMSInventoryUrl.post("ScheduledMas/Update", objupdate);
  }
}

export default new ScheduleMasterService();
